import React from 'react';

import Icon from '@material-ui/core/Icon';

import Box from '@material-ui/core/Box';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Select from '@material-ui/core/Select';
import { makeStyles } from '@material-ui/core/styles';

import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    DatePicker,
    TimePicker
} from '@material-ui/pickers';

import SaveButton from './SaveButton';
import { getTimeZone } from '../common';


const useStyles = makeStyles(theme => ({
    formControl: {
        minWidth: 120,
    },
    yesNoField: {
        minWidth: 182,
    },
    subTitle: {
        marginTop: 20,
        marginBottom: -18
    }
}));

const toBinary = (val) => val ? 1 : 0;

const WeddingTab = (props) => {
    const {
        officiants,
        couple,
        setCouple,
        handleChange,
        state
    } = props;

    const classes = useStyles();

    const timeZone = getTimeZone(couple.wedding_date*1000);

    const [formErrors, setFormErrors] = React.useState({});
    const isApproved = couple.couple_agree_date && couple.couple_agree_date !== '0000-00-00 00:00:00';

    /* NOTE: if we later make it possible to clear the officiant, then we need to change the logic in Couple.js for handleChange to undo the couple_type. Check with Angela. */

    return (
        <form>
            <Grid container spacing={3}>
                <Grid item xs={6}>
                    <FormControl className={classes.formControl}>
                        <InputLabel id="wedding-officiant-label">Officiant</InputLabel>
                        <Select
                            labelid="wedding-officiant-label"
                            id="wedding-officiant"
                            disabled={(window.isAdmin || window.isLimitedAdmin) ? false : true}
                            value={officiants.length > 0 ? (state.officiant_user_id || '') : ''}
                            onChange={handleChange('officiant_user_id')}
                        >
                            {officiants.length > 0 && officiants.map(item => (
                                <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>
            <Grid container spacing={3}>
                <Grid item xs={6}>
                    <TextField
                        fullWidth
                        margin="normal"
                        onChange={handleChange('venue')}
                        label="Venue Name"
                        value={state.venue || ''}
                    />
                    <TextField
                        fullWidth
                        margin="normal"
                        onChange={handleChange('location')}
                        label="Venue Address"
                        value={state.location || ''}
                    />
                </Grid>
                <Grid item xs={6}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <DatePicker
                            margin="normal"
                            id="wedding-date"
                            label="Wedding Date"
                            format="MM/dd/yyyy"
                            fullWidth
                            disabled={(window.isAdmin || window.isLimitedAdmin) ? false : isApproved}
                            value={state.wedding_date}
                            onChange={handleChange('wedding_date')}
                            required
                        />
                        <TimePicker
                            margin="normal"
                            id="time-picker-dialog"
                            label={`Wedding Time (${timeZone.initials})`}
                            fullWidth
                            disabled={(window.isAdmin || window.isLimitedAdmin) ? false : isApproved}
                            value={state.wedding_date}
                            onChange={handleChange('wedding_date')}
                            required
                        />
                    </MuiPickersUtilsProvider>
                </Grid>
            </Grid>
            <Box mt={2}>
                <Typography className={classes.subTitle} variant="overline" color="primary" display="block">
                    Ceremony / Atmosphere
                </Typography>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            margin="normal"
                            onChange={handleChange('ic_notes.length')}
                            label="Length"
                            value={state.ic_notes.length || ''}
                        />
                        <TextField
                            fullWidth
                            margin="normal"
                            onChange={handleChange('ic_notes.religious_or_not')}
                            label="Religious/Non Religious"
                            value={state.ic_notes.religious_or_not || ''}
                        />
                        <TextField
                            fullWidth
                            margin="normal"
                            onChange={handleChange('ic_notes.humour_or_serious')}
                            label="Humour/light hearted or serious"
                            value={state.ic_notes.humour_or_serious || ''}
                        />
                        <TextField
                            fullWidth
                            margin="normal"
                            onChange={handleChange('ic_notes.readings')}
                            label="Reading(s) - someone else involved?"
                            value={state.ic_notes.readings || ''}
                        />
                        <Box mb={1}>
                            <Typography className={classes.subTitle} variant="overline" display="block">
                                Vows
                            </Typography>
                        </Box>
                        <Box pl={1} mb={1}>
                            <TextField
                                fullWidth
                                margin="normal"
                                onChange={handleChange('ic_notes.vows_write_own_or_stock')}
                                label="Write their own or use stock?"
                                value={state.ic_notes.vows_write_own_or_stock || ''}
                            />
                            <TextField
                                fullWidth
                                margin="normal"
                                onChange={handleChange('ic_notes.vows_read_or_repeat')}
                                label="Read or repeat?"
                                value={state.ic_notes.vows_read_or_repeat || ''}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </Box>
            <Box mt={2}>
                <Typography className={classes.subTitle} variant="overline" color="primary" display="block">
                    Logistics
                </Typography>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            margin="normal"
                            onChange={handleChange('count_party')}
                            label="Wedding Party #'s (including the Bride and Groom)"
                            value={state.count_party || ''}
                        />
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    margin="normal"
                                    onChange={handleChange('count_flower')}
                                    label="Flower Girls"
                                    value={state.count_flower || ''}
                                />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    margin="normal"
                                    onChange={handleChange('count_ring')}
                                    label="Ring Bearers"
                                    value={state.count_ring || ''}
                                />
                            </Grid>
                        </Grid>
                        <TextField
                            fullWidth
                            margin="normal"
                            onChange={handleChange('wedding_colours')}
                            label="Wedding Colours"
                            value={state.wedding_colours || ''}
                        />
                        <TextField
                            select
                            className={classes.yesNoField}
                            margin="normal"
                            onChange={handleChange('wedding_outside')}
                            label="Is the wedding outside?"
                            value={state.wedding_outside || 0}
                            SelectProps={{
                                autoWidth: true
                            }}
                        >
                            <MenuItem value={0}>
                                No
                            </MenuItem>
                            <MenuItem value={1}>
                                Yes
                            </MenuItem>
                        </TextField>
                        <TextField
                            fullWidth
                            margin="normal"
                            onChange={handleChange('ic_notes.brides_processional')}
                            label="Bride's Processional - with Dad / Both parents or other"
                            value={state.ic_notes.brides_processional || ''}
                        />
                        <TextField
                            fullWidth
                            margin="normal"
                            onChange={handleChange('ic_notes.parental_situation')}
                            label="Parental Situation"
                            value={state.ic_notes.parental_situation || ''}
                        />
                        <TextField
                            select
                            className={classes.yesNoField}
                            margin="normal"
                            onChange={handleChange('ic_notes.needs_rehearsal')}
                            label="Requires rehearsal?"
                            value={toBinary(couple.has_rehearsal)}
                            SelectProps={{
                                autoWidth: true
                            }}
                            disabled
                        >
                            <MenuItem value={1}>
                                Yes
                            </MenuItem>
                            <MenuItem value={0}>
                                No
                            </MenuItem>
                        </TextField>
                    </Grid>
                </Grid>
            </Box>
            <Box mt={2}>
                <Typography className={classes.subTitle} variant="overline" color="primary" display="block">
                    Other Notes
                </Typography>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            margin="normal"
                            multiline
                            onChange={handleChange('other_notes')}
                            label="Notes"
                            value={state.other_notes || ''}
                        />
                    </Grid>
                </Grid>
            </Box>
            <Box mt={4} mb={3}>
                <Grid
                    container
                    direction="row"
                    justify="center"
                    alignItems="center"
                >
                    <Grid item xs={12} sm={4}>
                        <SaveButton
                            state={state}
                            coupleId={couple.id}
                            setCouple={setCouple}
                            setFormErrors={setFormErrors}
                        />
                    </Grid>
                </Grid>
            </Box>
        </form>
    );
};

export default WeddingTab;
